import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-subjects-chooser-dialog',
  templateUrl: './subjects-chooser-dialog.component.html',
  styleUrls: ['./subjects-chooser-dialog.component.scss']
})
export class SubjectsChooserDialogComponent implements OnInit {
  selectedTab = 0;
  offer;
  showOffer = false;
  offerStatus = "NOT_ELIGIBLE";
  constructor(private dialogRef:MatDialogRef<SubjectsChooserDialogComponent>) { }

  ngOnInit() {

  }
  nextTab(tabID) {
    this.selectedTab = tabID;
  }
  setOffer(offer) {
    this.offer = offer;
    this.showOffer = offer.showOffer;
  }
  offerStatusChange(offerStatus) {
    this.offerStatus = offerStatus;
    this.selectedTab = 3;
  }
  closeDialog(){
    this.dialogRef.close();
  }
}
